import { useContext } from "react";
import { EmployeePageContext } from "../contexts/employeePageContext";

const useEmployeePageContext = () => useContext(EmployeePageContext);

export { useEmployeePageContext };
